import Tile from './Tile'

export default Tile
// eslint-disable-next-line import/export
export * from './Tile'
